import React from 'react';

import { ErrorMessages } from 'common/components/Form/ErrorMessages';
import GoogleButton from 'common/components/socialNetworks/GoogleButton';
import { IdentityProviderTypes } from 'common/constants/IdentityProvidersTypes';
import { Credentials } from 'common/services/authentication/tokens';
import { openFacebookAccountRecoveryModal } from 'common/services/modal';
import { getFacebookCredentialResponse } from 'common/third_party/facebook';
import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

export type CredentialsToSubmit = Credentials & {
  provider: IdentityProviderTypes;
};

type Props = {
  errorMessages: string[];
  onSocialClick: (credentials: CredentialsToSubmit) => void;
  submitting: boolean;
  fbButton?: boolean;
  fbModal?: boolean;
};

const SocialSignButtons = ({
  errorMessages,
  onSocialClick,
  submitting,
  fbButton,
  fbModal
}: Props) => {
  const handleFacebookConnect = async () => {
    const credentials = await getFacebookCredentialResponse();
    onSocialClick({ ...credentials, provider: IdentityProviderTypes.FACEBOOK });
  };

  return (
    <>
      <ErrorMessages messages={errorMessages} />
      <div className="form-social-connect">
        {trans('userspace.sign.social.connect')}
      </div>
      <div className={styles.socialSignButtons}>
        {fbButton && (
          <button
            className="button-sign-social button-sign-fb"
            disabled={submitting}
            onClick={
              fbModal ? openFacebookAccountRecoveryModal : handleFacebookConnect
            }
            type="button"
          />
        )}
        {submitting ? (
          <button
            className="button-sign-social button-sign-gplus"
            disabled={submitting}
            type="button"
          />
        ) : (
          <GoogleButton onSocialClick={onSocialClick} />
        )}
      </div>
    </>
  );
};

export default SocialSignButtons;
